var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-group', {
    staticClass: "combobox",
    attrs: {
      "label": _vm.label,
      "errors": _vm.errors
    },
    on: {
      "focus": _vm.focus
    }
  }, [_c('multiselect', {
    ref: "primaryInput",
    attrs: {
      "placeholder": _vm.placeholder,
      "searchable": true,
      "value": _vm.internalValue,
      "options": _vm.optionsWithDefault,
      "allow-empty": _vm.allowEmpty,
      "clear-on-select": true,
      "close-on-select": true,
      "label": _vm.labelKey,
      "internal-search": _vm.internalSearch,
      "hide-selected": false,
      "track-by": _vm.idKey,
      "multiple": _vm.multiple,
      "disabled": _vm.disabled,
      "loading": _vm.isLoading,
      "select-label": _vm.$t('hints.select'),
      "deselect-label": _vm.$t('hints.deselect'),
      "selected-label": _vm.$t('hints.selected')
    },
    on: {
      "search-change": _vm.onSearchChange,
      "input": _vm.onInput,
      "open": function($event) {
        _vm.$emit('open')
      },
      "close": function($event) {
        _vm.$emit('close')
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_vm._t("option", [_vm._v("\n        " + _vm._s(props.option[_vm.labelKey]) + "\n      ")], {
          option: props.option
        })]
      }
    }])
  }, [_c('span', {
    slot: "noResult"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('hints.noResults')) + "\n    ")]), _vm._v(" "), (!_vm.searchTerm && _vm.options.length === 0) ? _c('span', {
    staticClass: "multiselect__no-options",
    slot: "beforeList"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('hints.noOptions')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "singleLabel"
  }, [_vm._t("singleLabel", [(_vm.internalValue) ? [_vm._v("\n          " + _vm._s(_vm.internalValue[_vm.labelKey]) + "\n        ")] : _vm._e()], {
    option: _vm.internalValue
  })], 2)], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64afeaf8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/Combobox.vue
// module id = 2023
// module chunks = 0